import { computed, defineComponent } from 'vue';
import { VCodeService } from '@/services/vcode.service';
import { useService } from '@kaokei/use-vue-service';
import { phonePattern, imageCodePattern } from '@/utils';
export default defineComponent({
  name: 'VCode',
  props: {
    phone: {
      type: String
    },
    imgCode: {
      type: String
    }
  },
  setup: function (props, _a) {
    // 这里的验证码服务是当前组件的，而不是从父组件获取
    // declareProviders([VCodeService]);
    var emit = _a.emit;
    var vcodeService = useService(VCodeService);
    var isValid = computed(function () {
      return props.phone && phonePattern.test(props.phone) && props.imgCode && imageCodePattern.test(props.imgCode);
    });
    var isActive = computed(function () {
      return isValid.value && vcodeService.countdownStatus === 'initial';
    });
    var onClickBtn = function () {
      if (isValid.value && props.phone && props.imgCode) {
        vcodeService.sendVerifiedCode({
          phone: props.phone,
          imgCode: props.imgCode,
          errFun: function () {
            vcodeService.getImageCode();
            emit('clearCode');
          }
        });
      }
    };
    var btnText = computed(function () {
      return vcodeService.countdownStatus === 'countdown' ? "".concat(vcodeService.countdownTime, "s\u540E\u91CD\u53D1") : '获取验证码';
    });
    return {
      isActive: isActive,
      onClickBtn: onClickBtn,
      btnText: btnText
    };
  }
});